/* eslint-disable no-param-reassign */
import { apiWorkerObj } from '@usap/core'
import apiConfig from '../../config/api-config'

const elsSearchURL = `${apiConfig.apiURL}/vehicle`
const filteredPageType = ['make_model_part', 'make_part']

const updateVehicleData = (meta, data, attributesData) => meta.map(element => {
  const responseDataElement = data.find(
    respElement => respElement.key === element.key,
  )
  if (responseDataElement) {
    element.options = responseDataElement.options
    element.value = attributesData.attributes[element.key] || ''
    element.disabled = false
  }

  return element
})

export const isPla = productDetails => Boolean(productDetails &&
  productDetails.isPla &&
  productDetails.selectedVehicle)

export const getYearRanges = productDetails => {
  const { year } = (productDetails && productDetails.attributes) || {}
  const range = year && year.year && year.year.includes('-') ? year.year.split('-') : []
  return Array(range.length)
    .fill()
    .map((_, index) => parseInt(range[0], 10) + index)
}

export const getVehicleFromAPI = (productDetails, selectedVehicle = {}) => (
  productDetails && productDetails.selectedVehicle) ||
  selectedVehicle || {}

export const canAddVehiclePLA = productDetails => Boolean(productDetails &&
    productDetails.isPla &&
    productDetails.selectedVehicle &&
    productDetails.selectedVehicle.year &&
    productDetails.selectedVehicle.make &&
    productDetails.selectedVehicle.model)

export const hasFullVehicleInfoPLA = productDetails => Boolean(productDetails &&
    productDetails.isPla &&
    productDetails.selectedVehicle &&
    productDetails.selectedVehicle.year &&
    productDetails.selectedVehicle.make &&
    productDetails.selectedVehicle.model &&
    productDetails.selectedVehicle.submodel &&
    productDetails.selectedVehicle.engine)

export const hasFullVehicleInfoNotPLA = productDetails => Boolean(productDetails &&
    !productDetails.isPla &&
    productDetails.selectedVehicle &&
    productDetails.selectedVehicle.year &&
    productDetails.selectedVehicle.make &&
    productDetails.selectedVehicle.model &&
    productDetails.selectedVehicle.submodel &&
    productDetails.selectedVehicle.engine)

export const getSequence = hasYearRangePla => (hasYearRangePla
  ? ['make', 'model', 'year', 'submodel', 'engine']
  : ['year', 'make', 'model', 'submodel', 'engine'])

export const getAttributes = (productDetails, sequence, isDirectData) => {
  const attributes = productDetails && productDetails.attributes
  if (!attributes) return {}
  return sequence.reduce(
    (data, elementKey) => {
      const attributesData = attributes[elementKey]
      if (attributesData) {
        data.sequence = [...data.sequence, elementKey]
        data.attributes[elementKey] = isDirectData
          ? attributesData
          : attributesData[`${elementKey}Name`] || attributesData[elementKey]
      }
      return data
    },
    { sequence: [], attributes: {} },
  )
}

export const isYearRangePla = productDetails => {
  const { year } = (productDetails && productDetails.attributes) || {}
  return year && year.year && year.year.includes('-')
}

export const getFilterData = (selectedData, keys) => keys.reduce((data, key) => {
  if (selectedData[key]) {
    data[key] = selectedData[key]
  }
  return data
}, {})

export const getElementByKey = (data, key) => data.find(element => element.key === key)

export const dataAPI = (op, data, key) => apiWorkerObj.dataAPI(
  op, data, key, elsSearchURL, apiConfig.apiKey,
)

export const getMetaFromAPI = (attributesData, vehicleData, years) => {
  const apiPromiseArray = attributesData.sequence.map(key => {
    if (key === 'year') return Promise.resolve({ key: 'year', options: years })
    const { api, apiProps } = vehicleData.meta.find(element => element.key === key) || {}
    const filterData = getFilterData(attributesData.attributes, apiProps)
    return dataAPI(api, filterData, key)
  })

  return Promise.all(apiPromiseArray)
    .then(response => updateVehicleData(vehicleData.meta, response, attributesData))
}

export const yearRangeVehicleMetaFormat = (
  sequence,
  vehicleData,
  isYearRange = true,
  hasModel = false,
) => sequence.map(key => {
  const selectedKeyData = vehicleData.find(element => element.key === key)
  if (key === 'make') {
    delete selectedKeyData.apiProps
  }
  if (key === 'year') {
    selectedKeyData.apiProps = ['make', 'model']
    selectedKeyData.api = 'getYearsByMakeModel'
    selectedKeyData.open = isYearRange
    selectedKeyData.next = 'submodel'
    selectedKeyData.disabled = !hasModel
  }
  if (key === 'model') {
    // Remove this if api need make and year in payload
    selectedKeyData.apiProps = ['make']
    selectedKeyData.next = 'year'
  }
  return selectedKeyData
})

export const getYearRangeInitialData = (attributesData, vehicleData, years) => {
  const { attributes } = attributesData
  const getMake = dataAPI('getMakes', {}, 'make')
  const getModelByYear = dataAPI(
    'getModels',
    { make: attributes.make },
    'model',
  )
  return Promise.all([getMake, getModelByYear]).then(response => {
    const updatedResponse = [...response, { key: 'year', options: years }]
    const updatedData = updateVehicleData(
      vehicleData.meta,
      updatedResponse,
      attributesData,
    )
    const sequence = getSequence(true)
    return yearRangeVehicleMetaFormat(sequence, updatedData, true, true)
  })
}
export const getSEOInitialData = (attributesData, vehicleData) => {
  const { attributes } = attributesData
  const hasModel = attributes.model
  const hasYear = attributes.year
  const getMake = dataAPI('getMakes', {}, 'make')
  const getModelByMake = dataAPI(
    'getModels',
    { make: attributes.make },
    'model',
  )
  const getYearsByMakeModel = hasModel
    ? dataAPI(
      'getYearsByMakeModel',
      { make: attributes.make, model: attributes.model },
      'year',
    )
    : []
  const yetSubModelByMokeModelYear = dataAPI(
    'getSubModels',
    {
      make: attributes.make,
      model: attributes.model,
      year: attributes.year,
    },
    'submodel',
  )
  let promiseArray = []
  if (hasYear) {
    promiseArray = [getMake, getModelByMake, getYearsByMakeModel, yetSubModelByMokeModelYear]
  } else if (hasModel) {
    promiseArray = [getMake, getModelByMake, getYearsByMakeModel]
  } else {
    promiseArray = [getMake, getModelByMake]
  }

  return Promise.all(promiseArray).then(response => {
    const updatedResponse = [...response]
    const updatedData = updateVehicleData(
      vehicleData.meta,
      updatedResponse,
      attributesData,
    )
    const sequence = getSequence(true)
    return yearRangeVehicleMetaFormat(
      sequence,
      updatedData,
      false,
      attributes.model,
    )
  })
}
export const deepClone = data => {
  if (!data) return data
  return JSON.parse(JSON.stringify(data))
}

export const getYearRange = node => {
  let [low, high] = node.split('-')
  low = Number(low)
  high = Number(high)
  return Array(high + 1 - low)
    .fill()
    .map((_, index) => low + index)
    .reverse()
    .map(String)
}

export const getSelectedKeyword = state => {
  if (__BROWSER__) {
    let keyword = ''

    if (
      typeof state.selectedKeyword !== 'undefined' &&
      (location.pathname === '/search' || location.pathname === '/search/') // eslint-disable-line no-restricted-globals
    ) {
      keyword = state.selectedKeyword
    }

    return keyword
  }

  return ''
}

export const isSEOPage = (pageType = '', dynamicApi) => {
  const apiData = dynamicApi || (__BROWSER__ && window.__COMBINED_DATA__)
  if (pageType.includes('directory')) {
    return false
  }
  if (pageType === 'year_make_model' && apiData && apiData.vehicle) {
    return false
  }
  if (filteredPageType.includes(pageType)) {
    return true
  }
  const hasMake = pageType.includes('make')
  const hasPart = pageType.includes('part')
  const hasYear = pageType.includes('year')
  if (hasMake && !hasPart) {
    return true
  }
  if (hasMake && hasPart && hasYear) {
    const vehicle = apiData && apiData.products && apiData.products.selectedVehicle
    const hasCompleteVehicle = Object.keys(vehicle || {}).length >= 3

    if (hasCompleteVehicle) {
      return false
    }
    return true
  }
  return false
}
/* eslint-enable no-param-reassign */
